<template>
    <div class="gallery-carousel-card">
        <ThLink
            v-if="data.link"
            v-bind="buttonBind"
        >
            <CmsImage
                :data="data.image"
                :is-eager="hasEagerImage"
                fit="cover"
            />
        </ThLink>

        <CmsImage
            v-else
            :data="data.image"
            fit="cover"
        />
    </div>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'
import type { GalleryCarouselCardFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms'

import ThLink from '@/components/ui/buttons/ThLink.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    data: GalleryCarouselCardFragment
    hasEagerImage?: boolean
}>()

const buttonBind = useCmsLink(toRef(() => props.data.link))
</script>

<style lang="scss" scoped>
.gallery-carousel-card {
    position: relative;
    border: 1px solid $grey-300;
    z-index: 2;
    width: 100%;
    height: 100%;
    transform-origin: center;
}
</style>
